/**
 * Brand-aware asset resolver.
 *
 * All images are loaded from a remote public URL (VITE_ASSETS_BASE_URL) so
 * they are never bundled in the repo. To add a new brand: add a row to
 * BRAND_LOGOS below using the same baseUrl.
 *
 * Selection is driven by `config.theme` (VITE_THEME).
 */

import { config } from '@/lib/config'

const baseUrl = config.assetsBaseUrl

interface BrandLogos {
  /** Logo to render on dark surfaces. */
  dark:  string
  /** Logo to render on light surfaces. */
  light: string
}

const BRAND_LOGOS: Record<string, BrandLogos> = {
  billeteraPais: {
    dark:  `${baseUrl}/logo-full.png`,
    light: `${baseUrl}/logo-full.png`,
  },
  masPay: {
    dark:  `${baseUrl}/logo-full.png`,
    light: `${baseUrl}/logo-full.png`,
  },
  totalPay: {
    dark:  `${baseUrl}/logo-full.png`,
    light: `${baseUrl}/logo-full.png`,
  },
}

export function getBrandLogos(): BrandLogos {
  return BRAND_LOGOS[config.theme] ?? BRAND_LOGOS.billeteraPais
}

export function getBankLogoUrl(bankName: string, variant?: 'largo'): string {
  const suffix = variant ? `-${variant}` : ''
  return `${baseUrl}/${bankName}${suffix}.svg`
}

export function getCardLogoUrl(cardType: string): string {
  return `${baseUrl}/${cardType}.svg`
}
